// extracted by mini-css-extract-plugin
export default {"header__container":"Header_header__container__Id7+w","logo__text":"Header_logo__text__ClJyV","main__menu":"Header_main__menu__JW6sM","social__links":"Header_social__links__mxgbq"};